module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-218e48e4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logout.vue
// module id = 316
// module chunks = 1 2